const TOKEN_KEY = 'token';

export const getToken = () => {
  const token = localStorage.getItem(TOKEN_KEY);
  return token?.replace(/^Bearer\s+/i, '').trim() || '';
};

export const setToken = (token) => {
  const normalizedToken = token?.replace(/^Bearer\s+/i, '').trim();
  if (normalizedToken) {
    localStorage.setItem(TOKEN_KEY, normalizedToken);
  }
};

export const getAuthHeaders = () => {
  const token = getToken();
  return token ? { Authorization: `Bearer ${token}` } : {};
};

export const clearToken = () => {
  localStorage.removeItem(TOKEN_KEY);
};

export const isAuthError = (error) => {
  const message = error?.response?.data?.message?.toString().toLowerCase() || '';
  return (
    error?.response?.status === 401 ||
    message.includes('invalid token') ||
    message.includes('jwt expired') ||
    message.includes('token expired') ||
    message.includes('unauthorized')
  );
};
